import { render } from "./Join.vue?vue&type=template&id=7bb03f0e&bindings={\"classroom\":\"props\",\"session\":\"props\",\"flash\":\"props\",\"sessionRequest\":\"props\",\"csrf_token\":\"props\"}"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7bb03f0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bb03f0e')) {
    api.reload('7bb03f0e', script)
  }
  
  module.hot.accept("./Join.vue?vue&type=template&id=7bb03f0e&bindings={\"classroom\":\"props\",\"session\":\"props\",\"flash\":\"props\",\"sessionRequest\":\"props\",\"csrf_token\":\"props\"}", () => {
    api.rerender('7bb03f0e', render)
  })

}

script.__file = "resources/js/Pages/AssignedClassrooms/Classroom/Join.vue"

export default script